// import { useState, useEffect, useCallback } from "react";
// import {
//   LayoutDashboard, Trash2, Clock, Sparkles,
//   CheckCircle2, Calendar, TrendingUp
// } from "lucide-react";
// import DashboardLayout from "../../components/DashboardLayout";
// import { useAuth } from "../../hooks/useAuth";
// import { useNavigate } from "react-router-dom";
// import { supabase } from "../../lib/supabaseClient";

// const COOLDOWN_MS = 15 * 60 * 1000;

// function getToday() { return new Date().toISOString().split("T")[0]; }

// function formatTime(iso) {
//   return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
// }


// export default function ResidentMyTrash() {
//   const { profile } = useAuth();
//   const navigate    = useNavigate();
//   const propertyId  = profile?.property_id;
//   const unitNumber  = profile?.unit_number;
//   const userId      = profile?.id;
//   const today       = getToday();

//   const NAV = [
//   { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard", active: true },
//   { label: "My Trash",  icon: Trash2,  path: "/resident/my-trash" },
//   { label: "History",   icon: Clock,   path: "/resident/history" },
//   { label: "Services",  icon: Sparkles, onClick: () => navigate("/resident/services") },
// ];

//   const [valetStatus,  setValetStatus]  = useState(null);
//   const [todaySubs,    setTodaySubs]    = useState([]);
//   const [weekCount,    setWeekCount]    = useState(0);
//   const [monthCount,   setMonthCount]   = useState(0);
//   const [showModal,    setShowModal]    = useState(false);
//   const [submitting,   setSubmitting]   = useState(false);
//   const [submitError,  setSubmitError]  = useState("");
//   const [cooldownEnd,  setCooldownEnd]  = useState(null);
//   const [cooldownDone, setCooldownDone] = useState(true);
//   const [timeLeft,     setTimeLeft]     = useState(0);

//   // Fetch valet status
//   const fetchValetStatus = useCallback(async () => {
//     if (!propertyId) return;
//     const { data } = await supabase
//       .from("valet_status")
//       .select("status")
//       .eq("property_id", propertyId)
//       .eq("service_date", today)
//       .maybeSingle();
//     setValetStatus(data?.status || null);
//   }, [propertyId, today]);

//   // Fetch today's submissions + stats
//   const fetchSubs = useCallback(async () => {
//     if (!propertyId || !userId) return;

//     const now      = new Date();
//     const weekAgo  = new Date(now); weekAgo.setDate(now.getDate() - 6);
//     const monthAgo = new Date(now); monthAgo.setDate(now.getDate() - 29);

//     const [{ data: todayData }, { count: wCount }, { count: mCount }] = await Promise.all([
//       supabase.from("activity_logs")
//         .select("id, created_at, metadata")
//         .eq("property_id", propertyId).eq("user_id", userId)
//         .eq("action", "resident_trash_submitted")
//         .gte("created_at", `${today}T00:00:00`)
//         .order("created_at", { ascending: false }),
//       supabase.from("activity_logs")
//         .select("*", { count: "exact", head: true })
//         .eq("property_id", propertyId).eq("user_id", userId)
//         .eq("action", "resident_trash_submitted")
//         .gte("created_at", weekAgo.toISOString()),
//       supabase.from("activity_logs")
//         .select("*", { count: "exact", head: true })
//         .eq("property_id", propertyId).eq("user_id", userId)
//         .eq("action", "resident_trash_submitted")
//         .gte("created_at", monthAgo.toISOString()),
//     ]);

//     setTodaySubs(todayData || []);
//     setWeekCount(wCount || 0);
//     setMonthCount(mCount || 0);

//     // Cooldown check
//     if (todayData && todayData.length > 0) {
//       const lastTime = new Date(todayData[0].created_at).getTime();
//       const endsAt   = lastTime + COOLDOWN_MS;
//       if (endsAt > Date.now()) {
//         setCooldownEnd(endsAt);
//         setCooldownDone(false);
//         setTimeLeft(Math.max(0, endsAt - Date.now()));
//       } else {
//         setCooldownDone(true);
//       }
//     }
//   }, [propertyId, userId, today]);

//   useEffect(() => { fetchValetStatus(); fetchSubs(); }, [fetchValetStatus, fetchSubs]);

//   // Realtime valet status
//   useEffect(() => {
//     if (!propertyId) return;
//     const ch = supabase.channel("mytrash_vs")
//       .on("postgres_changes", { event: "*", schema: "public", table: "valet_status", filter: `property_id=eq.${propertyId}` }, fetchValetStatus)
//       .subscribe();
//     return () => supabase.removeChannel(ch);
//   }, [propertyId, fetchValetStatus]);

//   // Cooldown timer
//   useEffect(() => {
//     if (cooldownDone || !cooldownEnd) return;
//     const interval = setInterval(() => {
//       const left = Math.max(0, cooldownEnd - Date.now());
//       setTimeLeft(left);
//       if (left <= 0) { setCooldownDone(true); clearInterval(interval); }
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [cooldownEnd, cooldownDone]);

//   const handleSubmit = async () => {
//     setSubmitting(true); setSubmitError("");
//     try {
//       const { error } = await supabase.from("activity_logs").insert({
//         property_id: propertyId, user_id: userId,
//         action: "resident_trash_submitted",
//         metadata: { unit_number: unitNumber, service_date: today },
//       });
//       if (error) throw error;
//       const endsAt = Date.now() + COOLDOWN_MS;
//       setCooldownEnd(endsAt); setCooldownDone(false);
//       setTimeLeft(COOLDOWN_MS); setShowModal(false);
//       fetchSubs();
//     } catch (err) { setSubmitError(err.message); }
//     setSubmitting(false);
//   };

//   const canSubmit  = valetStatus === "on_site" && cooldownDone;
//   const mins = Math.floor(timeLeft / 60000);
//   const secs = Math.floor((timeLeft % 60000) / 1000);

//   return (
//     <DashboardLayout role="resident" title="My Trash" navItems={NAV}>

//       {/* Header */}
//       <div className="fu" style={{ marginBottom: 24 }}>
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--g600)", marginBottom: 6 }}>Resident Portal</div>
//         <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", margin: 0 }}>My Trash</h2>
//         <p style={{ fontSize: 13, color: "var(--mut)", marginTop: 4 }}>Unit <strong style={{ color: "var(--g700)" }}>#{unitNumber || "—"}</strong></p>
//       </div>

//       {/* Stats */}
//       <div className="fu d1" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 20 }}>
//         {[
//           { label: "Today",      value: todaySubs.length, color: "var(--g600)", bg: "var(--g50)",  border: "var(--g200)", icon: Trash2 },
//           { label: "This Week",  value: weekCount,        color: "#1565c0",     bg: "#e3f2fd",     border: "#90caf9",     icon: Calendar },
//           { label: "This Month", value: monthCount,       color: "#e65100",     bg: "#fff3e0",     border: "#ffb74d",     icon: TrendingUp },
//         ].map(({ label, value, color, bg, border, icon: Icon }) => (
//           <div key={label} style={{ background: bg, border: `1.5px solid ${border}`, borderRadius: 12, padding: "14px 12px", textAlign: "center" }}>
//             <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{value}</div>
//             <div style={{ fontSize: 10, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: ".5px", marginTop: 4 }}>{label}</div>
//           </div>
//         ))}
//       </div>

//       {/* Submit Button Card */}
//       <div className="fu d2" style={{
//         background: "#fff", borderRadius: 14,
//         border: `1.5px solid ${canSubmit ? "var(--g300)" : "var(--ln)"}`,
//         padding: "24px 20px", marginBottom: 20, textAlign: "center",
//       }}>
//         <div style={{
//           width: 56, height: 56, borderRadius: "50%",
//           background: canSubmit ? "var(--g50)" : "#f5f5f5",
//           border: `2px solid ${canSubmit ? "var(--g300)" : "#e0e0e0"}`,
//           display: "flex", alignItems: "center", justifyContent: "center",
//           margin: "0 auto 14px",
//         }}>
//           <Trash2 size={24} color={canSubmit ? "var(--g600)" : "#bdbdbd"} strokeWidth={1.5} />
//         </div>

//         <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", marginBottom: 6 }}>
//           Trash is out
//         </div>
//         <div style={{ fontSize: 13, color: "var(--mut)", marginBottom: 18, lineHeight: 1.6 }}>
//           {valetStatus === "on_site"
//             ? cooldownDone ? "Valet is on-site — tap to confirm." : "Cooldown active — wait to submit again."
//             : valetStatus === "on_the_way" ? "Valet is on the way. Button activates on arrival."
//             : valetStatus === "completed"  ? "Today's service is complete."
//             : "Button activates when valet arrives on-site."
//           }
//         </div>

//         {submitError && (
//           <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginBottom: 14, textAlign: "left" }}>
//             {submitError}
//           </div>
//         )}

//         <button onClick={() => canSubmit && setShowModal(true)} disabled={!canSubmit} style={{
//           background: canSubmit ? "linear-gradient(135deg, var(--g600), var(--g500))" : "#e0e0e0",
//           color: canSubmit ? "#fff" : "#9e9e9e", border: "none", borderRadius: 10,
//           padding: "13px 28px", fontSize: 14.5, fontWeight: 700,
//           cursor: canSubmit ? "pointer" : "not-allowed",
//           width: "100%", maxWidth: 300,
//           boxShadow: canSubmit ? "0 4px 14px rgba(34,107,65,.3)" : "none",
//           transition: "all .3s",
//         }}>
//           {!cooldownDone ? `⏳ ${mins}:${secs.toString().padStart(2, "0")} cooldown` : canSubmit ? "✓ Confirm Trash Submission" : "Not available yet"}
//         </button>
//       </div>

//       {/* Today's Submissions */}
//       <div className="fu d3">
//         <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
//           Today's Submissions
//         </div>
//         {todaySubs.length === 0 ? (
//           <div style={{ textAlign: "center", padding: "20px", background: "#fafafa", borderRadius: 12, border: "1.5px dashed var(--ln)", fontSize: 13, color: "var(--mut)" }}>
//             No submissions today yet.
//           </div>
//         ) : (
//           <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
//             {todaySubs.map((s, i) => (
//               <div key={s.id} style={{
//                 display: "flex", alignItems: "center", gap: 12,
//                 padding: "11px 14px", borderRadius: 10,
//                 background: "var(--g50)", border: "1px solid var(--g200)",
//               }}>
//                 <CheckCircle2 size={16} color="var(--g600)" strokeWidth={2} />
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>Trash submitted — Unit #{unitNumber}</div>
//                   <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>{formatTime(s.created_at)}</div>
//                 </div>
//                 {i === 0 && <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 20, background: "var(--g600)", color: "#fff", textTransform: "uppercase", letterSpacing: ".5px" }}>Latest</span>}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Confirm Modal */}
//       {showModal && (
//         <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
//           <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,.16)", animation: "fadeUp .2s ease", textAlign: "center" }}>
//             <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--g50)", border: "2px solid var(--g200)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
//               <Trash2 size={24} color="var(--g600)" strokeWidth={1.8} />
//             </div>
//             <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 8 }}>Confirm Submission</div>
//             <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 22 }}>
//               Submitting trash confirmation for <strong style={{ color: "var(--ink)" }}>Unit #{unitNumber}</strong>.<br />
//               A 15-minute cooldown will apply.
//             </div>
//             <div style={{ display: "flex", gap: 10 }}>
//               <button onClick={() => setShowModal(false)} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
//               <button onClick={handleSubmit} disabled={submitting} style={{ flex: 2, padding: "11px", borderRadius: 10, border: "none", background: submitting ? "var(--g300)" : "var(--g600)", cursor: submitting ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>
//                 {submitting ? "Submitting…" : "Yes, I did ✓"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`@keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
//     </DashboardLayout>
//   );
// }


import { useState, useEffect, useCallback } from "react";
import {
  LayoutDashboard, Trash2, Clock, Sparkles,
  CheckCircle2, Calendar, TrendingUp
} from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";

// ─── Constants ────────────────────────────────────────────────────────────────
const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes

function getToday() { return new Date().toISOString().split("T")[0]; }

function formatTime(iso) {
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export default function ResidentMyTrash() {
  const { profile } = useAuth();
  const navigate    = useNavigate();
  const propertyId  = profile?.property_id;
  const unitNumber  = profile?.unit_number;
  const userId      = profile?.id;
  const today       = getToday();

  const NAV = [
    { label: "Dashboard", icon: LayoutDashboard, path: "/resident/dashboard" },
    { label: "My Trash",  icon: Trash2,          path: "/resident/my-trash", active: true },
    { label: "History",   icon: Clock,            path: "/resident/history" },
    { label: "Services",  icon: Sparkles,         onClick: () => navigate("/resident/services") },
  ];

  const [valetStatus,  setValetStatus]  = useState(null);
  const [todaySubs,    setTodaySubs]    = useState([]);
  const [weekCount,    setWeekCount]    = useState(0);
  const [monthCount,   setMonthCount]   = useState(0);
  const [showModal,    setShowModal]    = useState(false);
  const [submitting,   setSubmitting]   = useState(false);
  const [submitError,  setSubmitError]  = useState("");
  const [cooldownEnd,  setCooldownEnd]  = useState(null);
  const [cooldownDone, setCooldownDone] = useState(true);
  const [timeLeft,     setTimeLeft]     = useState(0);

  const fetchValetStatus = useCallback(async () => {
    if (!propertyId) return;
    const { data } = await supabase
      .from("valet_status")
      .select("status")
      .eq("property_id", propertyId)
      .eq("service_date", today)
      .maybeSingle();
    setValetStatus(data?.status || null);
  }, [propertyId, today]);

  const fetchSubs = useCallback(async () => {
    if (!propertyId || !userId) return;

    const now      = new Date();
    const weekAgo  = new Date(now); weekAgo.setDate(now.getDate() - 6);
    const monthAgo = new Date(now); monthAgo.setDate(now.getDate() - 29);

    const [{ data: todayData }, { count: wCount }, { count: mCount }] = await Promise.all([
      supabase.from("activity_logs")
        .select("id, created_at, metadata")
        .eq("property_id", propertyId).eq("user_id", userId)
        .eq("action", "resident_trash_submitted")
        .gte("created_at", `${today}T00:00:00`)
        .order("created_at", { ascending: false }),
      supabase.from("activity_logs")
        .select("*", { count: "exact", head: true })
        .eq("property_id", propertyId).eq("user_id", userId)
        .eq("action", "resident_trash_submitted")
        .gte("created_at", weekAgo.toISOString()),
      supabase.from("activity_logs")
        .select("*", { count: "exact", head: true })
        .eq("property_id", propertyId).eq("user_id", userId)
        .eq("action", "resident_trash_submitted")
        .gte("created_at", monthAgo.toISOString()),
    ]);

    setTodaySubs(todayData || []);
    setWeekCount(wCount || 0);
    setMonthCount(mCount || 0);

    if (todayData && todayData.length > 0) {
      const lastTime = new Date(todayData[0].created_at).getTime();
      const endsAt   = lastTime + COOLDOWN_MS;
      if (endsAt > Date.now()) {
        setCooldownEnd(endsAt);
        setCooldownDone(false);
        setTimeLeft(Math.max(0, endsAt - Date.now()));
      } else {
        setCooldownDone(true);
      }
    }
  }, [propertyId, userId, today]);

  useEffect(() => { fetchValetStatus(); fetchSubs(); }, [fetchValetStatus, fetchSubs]);

  useEffect(() => {
    if (!propertyId) return;
    const ch = supabase.channel("mytrash_vs")
      .on("postgres_changes", { event: "*", schema: "public", table: "valet_status", filter: `property_id=eq.${propertyId}` }, fetchValetStatus)
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [propertyId, fetchValetStatus]);

  useEffect(() => {
    if (cooldownDone || !cooldownEnd) return;
    const interval = setInterval(() => {
      const left = Math.max(0, cooldownEnd - Date.now());
      setTimeLeft(left);
      if (left <= 0) { setCooldownDone(true); clearInterval(interval); }
    }, 1000);
    return () => clearInterval(interval);
  }, [cooldownEnd, cooldownDone]);

  const handleSubmit = async () => {
    setSubmitting(true); setSubmitError("");
    try {
      const { error } = await supabase.from("activity_logs").insert({
        property_id: propertyId, user_id: userId,
        action:   "resident_trash_submitted",
        metadata: { unit_number: unitNumber, service_date: today },
      });
      if (error) throw error;
      const endsAt = Date.now() + COOLDOWN_MS;
      setCooldownEnd(endsAt); setCooldownDone(false);
      setTimeLeft(COOLDOWN_MS); setShowModal(false);
      fetchSubs();
    } catch (err) { setSubmitError(err.message); }
    setSubmitting(false);
  };

  const canSubmit = valetStatus === "on_site" && cooldownDone;
  const mins = Math.floor(timeLeft / 60000);
  const secs = Math.floor((timeLeft % 60000) / 1000);

  return (
    <DashboardLayout role="resident" title="My Trash" navItems={NAV}>

      {/* Header */}
      <div className="fu" style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--g600)", marginBottom: 6 }}>Resident Portal</div>
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 500, color: "var(--ink)", margin: 0 }}>My Trash</h2>
        <p style={{ fontSize: 13, color: "var(--mut)", marginTop: 4 }}>Unit <strong style={{ color: "var(--g700)" }}>#{unitNumber || "—"}</strong></p>
      </div>

      {/* Stats */}
      <div className="fu d1" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 20 }}>
        {[
          { label: "Today",      value: todaySubs.length, color: "var(--g600)", bg: "var(--g50)",  border: "var(--g200)", icon: Trash2 },
          { label: "This Week",  value: weekCount,        color: "#1565c0",     bg: "#e3f2fd",     border: "#90caf9",     icon: Calendar },
          { label: "This Month", value: monthCount,       color: "#e65100",     bg: "#fff3e0",     border: "#ffb74d",     icon: TrendingUp },
        ].map(({ label, value, color, bg, border }) => (
          <div key={label} style={{ background: bg, border: `1.5px solid ${border}`, borderRadius: 12, padding: "14px 12px", textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{value}</div>
            <div style={{ fontSize: 10, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: ".5px", marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Submit Button Card */}
      <div className="fu d2" style={{
        background: "#fff", borderRadius: 14,
        border: `1.5px solid ${canSubmit ? "var(--g300)" : "var(--ln)"}`,
        padding: "24px 20px", marginBottom: 20, textAlign: "center",
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: canSubmit ? "var(--g50)" : "#f5f5f5",
          border: `2px solid ${canSubmit ? "var(--g300)" : "#e0e0e0"}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 14px",
        }}>
          <Trash2 size={24} color={canSubmit ? "var(--g600)" : "#bdbdbd"} strokeWidth={1.5} />
        </div>

        <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ink)", marginBottom: 6 }}>
          Trash is out
        </div>
        <div style={{ fontSize: 13, color: "var(--mut)", marginBottom: 18, lineHeight: 1.6 }}>
          {valetStatus === "on_site"
            ? cooldownDone
              ? "Service in progress — tap to confirm."
              : "Cooldown active — wait to submit again."
            : valetStatus === "on_the_way"
              ? "Valet is on the way. Button activates on arrival."
              : valetStatus === "completed"
                ? "Today's service is complete."
                : "Button activates when valet arrives on-site."
          }
        </div>

        {submitError && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginBottom: 14, textAlign: "left" }}>
            {submitError}
          </div>
        )}

        <button onClick={() => canSubmit && setShowModal(true)} disabled={!canSubmit} style={{
          background: canSubmit ? "linear-gradient(135deg, var(--g600), var(--g500))" : "#e0e0e0",
          color: canSubmit ? "#fff" : "#9e9e9e", border: "none", borderRadius: 10,
          padding: "13px 28px", fontSize: 14.5, fontWeight: 700,
          cursor: canSubmit ? "pointer" : "not-allowed",
          width: "100%", maxWidth: 300,
          boxShadow: canSubmit ? "0 4px 14px rgba(34,107,65,.3)" : "none",
          transition: "all .3s",
        }}>
          {!cooldownDone
            ? `⏳ ${mins}:${secs.toString().padStart(2, "0")} cooldown`
            : canSubmit
              ? "✓ Confirm Trash is Out"
              : "Not available yet"
          }
        </button>
      </div>

      {/* Today's Submissions */}
      <div className="fu d3">
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".6px", textTransform: "uppercase", color: "var(--mut)", marginBottom: 12 }}>
          Today's Submissions
        </div>
        {todaySubs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px", background: "#fafafa", borderRadius: 12, border: "1.5px dashed var(--ln)", fontSize: 13, color: "var(--mut)" }}>
            No submissions today yet.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {todaySubs.map((s, i) => (
              <div key={s.id} style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "11px 14px", borderRadius: 10,
                background: "var(--g50)", border: "1px solid var(--g200)",
              }}>
                <CheckCircle2 size={16} color="var(--g600)" strokeWidth={2} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>Trash is out — Unit #{unitNumber}</div>
                  <div style={{ fontSize: 11.5, color: "var(--mut)", marginTop: 2 }}>{formatTime(s.created_at)}</div>
                </div>
                {i === 0 && <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 20, background: "var(--g600)", color: "#fff", textTransform: "uppercase", letterSpacing: ".5px" }}>Latest</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Confirm Modal */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 360, boxShadow: "0 8px 40px rgba(0,0,0,.16)", animation: "fadeUp .2s ease", textAlign: "center" }}>
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--g50)", border: "2px solid var(--g200)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <Trash2 size={24} color="var(--g600)" strokeWidth={1.8} />
            </div>
            <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", marginBottom: 8 }}>Confirm Submission</div>
            <div style={{ fontSize: 13, color: "var(--mut)", lineHeight: 1.6, marginBottom: 22 }}>
              Confirming trash is out for <strong style={{ color: "var(--ink)" }}>Unit #{unitNumber}</strong>.<br />
              A 30-minute cooldown will apply.
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => setShowModal(false)} style={{ flex: 1, padding: "11px", borderRadius: 10, border: "1.5px solid var(--ln)", background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "var(--mut)" }}>Cancel</button>
              <button onClick={handleSubmit} disabled={submitting} style={{ flex: 2, padding: "11px", borderRadius: 10, border: "none", background: submitting ? "var(--g300)" : "var(--g600)", cursor: submitting ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700, color: "#fff" }}>
                {submitting ? "Submitting…" : "Yes, confirm ✓"}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </DashboardLayout>
  );
}